// AI-enrichment lookup
//
// `scripts/enrich-products.ts` runs against the Lovable AI Gateway and writes
// per-handle results into product-enrichment.json — { color, diameterCm }.
//
// At runtime the parser-driven `parseDiameterCm()` and color queries always
// run first; this cache is consulted as a *gap-filler* only. That keeps the
// cheap deterministic path in charge and lets AI inference fill the long tail.

import enrichmentJson from "./product-enrichment.json";

export type EnrichmentEntry = {
  color: string | null;
  diameterCm: number | null;
  source?: string;
  enrichedAt?: string;
};

const CACHE = enrichmentJson as Record<string, EnrichmentEntry>;

export function getEnrichment(handle: string | undefined | null): EnrichmentEntry | null {
  if (!handle) return null;
  return CACHE[handle] ?? null;
}

export function getEnrichedDiameter(handle: string | undefined | null): number | null {
  const e = getEnrichment(handle);
  return e?.diameterCm ?? null;
}

export function getEnrichedColor(handle: string | undefined | null): string | null {
  const e = getEnrichment(handle);
  return e?.color ?? null;
}
